import {
	axios
} from '../axios/request';

// 该文件只是为了记录所有的api数量，作用说明，方便维护

//获取文章列表
function getArticleList(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//动态列表
function getDynamicList(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取政策列表
function getPolicyList(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取文章详情
function getArticleDetail(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}
//获取动态详情
function getDynamicDetail(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取文章列表
function getPolicyDetail(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//园区文字列表
function getParkList(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取地图菜单列表
function getMenuList(url, params = {}) {
	return axios.get(url, {
		params: params
	})

}

//获取地图标记列表 /cdMapApi/api/getMarkListByMenuId
function getMarkList(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取项目类型信息 /cdMapApi/api/project/getTypeInfo
function getTypeInfo(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取配套类型信息/cdMapApi/api/assorts/getTypeInfo
function getassorts(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//通过项目类型获取标点列表 /cdMapApi/api/project/getMarksListByProjectType
function getMarksListByProjectType(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

// 配套、政府服务等详情页面 
function getDetail(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//  园区详情页 /cdMapApi/api/park/getDetailsByMarksId
function parkDetail(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取项目地区信息
function getArea(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取项目类型信息
function getProType(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

//获取项目列表
function getProList(url, data = {}) {
	return axios.post(url, data)
}

//获取项目详情
function getProDetail(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

// 热点商圈介绍
function hotIntro(url, params = {}) {
	return axios.get(url, {
		params: params
	})
}

export {
	getArticleList,
	getDynamicList,
	getPolicyList,
	getArticleDetail,
	getDynamicDetail,
	getPolicyDetail,
	getParkList,
	getMenuList,
	getMarkList,
	getTypeInfo,
	getassorts,
	getArea,
	getProType,
	getMarksListByProjectType,
	getDetail,
	parkDetail,
	getProList,
	getProDetail,
	hotIntro
}